import React, { Component } from "react";

export class Contact extends Component {
  render() {
    return (
      <div>
        <div id="contact">
          <div className="container">
            <div className="col-md-8">
              <div className="row">
                <div className="section-title">
                  <h2>Contacto</h2>
                  <div className="col-md-5 col-md-offset-7 contact-info">
                    <div className="contact-item">
                      <h3>Información de Contacto</h3>
                      <p>
                        <span>
                          <i className="fa fa-map-marker"></i> Dirección
                        </span>
                        {this.props.data ? this.props.data.address : "loading"}
                      </p>
                    </div>
                    <div className="contact-item">
                      <p>
                        <span>
                          <i className="fa fa-phone"></i> Teléfono
                        </span>{" "}
                        {this.props.data ? this.props.data.phone : "loading"}
                      </p>
                    </div>
                    <div className="contact-item">
                      <p>
                        <span>
                          <i className="fa fa-envelope-o"></i> Correo
                        </span>{" "}
                        {this.props.data ? this.props.data.email : "loading"}
                      </p>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="social">
                  <ul>
                    <li>
                      <a
                        href={this.props.data ? this.props.data.facebook : "/"}
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href={this.props.data ? this.props.data.youtube : "/"}>
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="footer">
          <div className="container text-center">
            <p>
              Facebook: {" "}
              <a href="https://www.facebook.com/alterne.mx/" rel="nofollow">
                Alterne.mx
              </a>
              <br />
                Alternative Electronics&reg; 2021
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
